export const arcs = [
  {
    id: "arc-daily",
    no: "01",
    title: "日常篇",
    tag: "故事起点",
    keywords: ["并盛町", "家庭教师登场", "搞笑日常"],
    summary:
      "里包恩以家庭教师的身份住进沢田家，纲吉被迫开始接受「成为首领」的训练。这一段以单元式日常为主，一边建立角色关系，一边用荒诞的桥段解释黑手党世界的规则。",
    points: [
      "确立纲吉「废柴」的起点形象，为后面的成长留出空间",
      "狱寺、山本、蓝波、云雀等主要人物陆续登场",
      "用喜剧节奏交代死气弹、家庭教师与家族的基本设定",
    ],
  },
  {
    id: "arc-kokuyo",
    no: "02",
    title: "黑曜篇",
    tag: "首个战斗高峰",
    keywords: ["六道骸", "黑曜中学", "幻术"],
    summary:
      "一群来自黑曜中学的转校生在校内引发骚动，幕后操纵者是掌握六道能力的六道骸。纲吉一行人第一次被迫以团队形式迎战真正意义上的敌人，战斗比重明显上升。",
    points: [
      "六道骸登场，带来幻术这一全新的战斗维度",
      "纲吉首次为保护同伴而主动迎战，而非被逼上阵",
      "守护者之间开始形成配合意识，团队轮廓初步成形",
    ],
  },
  {
    id: "arc-varia",
    no: "03",
    title: "瓦利亚篇",
    tag: "继承权之争",
    keywords: ["XANXUS", "戒指争夺战", "彭格列戒指"],
    summary:
      "彭格列内部的暗杀部队瓦利亚公开质疑纲吉的继承资格，双方以「戒指争夺战」的方式一决高下。这一段把作品的核心命题——谁有资格成为首领——摆到了台面上。",
    points: [
      "七位守护者逐一上场，各自的属性与战斗风格被完整展示",
      "彭格列戒指成为贯穿后续的重要道具",
      "纲吉必须在众目注视下证明自己，压力感拉到高点",
    ],
  },
  {
    id: "arc-future",
    no: "04",
    title: "未来篇",
    tag: "篇幅最长的篇章",
    keywords: ["十年后", "白兰", "匣兵器"],
    summary:
      "纲吉等人被送往十年后的世界，发现那里已经被密鲁菲奥雷家族与白兰掌控，同伴身处绝境。为了回到原本的时间线，他们必须在陌生的未来中重新训练、重新战斗。",
    points: [
      "引入匣兵器与戒指升级，战斗体系整体升级换代",
      "白兰作为跨平行世界的对手，制造出强烈的无力感",
      "老角色以十年后的姿态回归，是很多观众印象最深的部分",
    ],
  },
  {
    id: "arc-rainbow",
    no: "05",
    title: "彩虹之子篇",
    tag: "解开诅咒的线索",
    keywords: ["彩虹之子", "尤尼", "奶嘴"],
    summary:
      "围绕彩虹之子的诅咒与奶嘴展开，解释里包恩等人为何会以婴儿形态存在。这一段落把此前埋下的伏笔集中回收，也让里包恩这个角色的过去变得更加清晰。",
    points: [
      "补完里包恩与其他彩虹之子的背景与羁绊",
      "尤尼的登场让故事的情感线更加沉重",
      "解释诅咒的同时，也为后续的对抗埋下结构性矛盾",
    ],
  },
  {
    id: "arc-simon",
    no: "06",
    title: "继承式篇",
    tag: "动画之后的故事",
    keywords: ["西蒙家族", "古里炎真", "地之焰"],
    summary:
      "纲吉即将继承彭格列十代目之位，西蒙家族的介入却让继承式变成新的冲突。炎真与纲吉的高度相似，让这一段更像是纲吉与「过去的自己」的一次对话。",
    points: [
      "引入地属性火焰，扩展原有的七属性体系",
      "炎真与纲吉的对照关系是这一段的情感核心",
      "继承式的设定把彭格列的历史与当下连接起来",
    ],
  },
  {
    id: "arc-representative",
    no: "07",
    title: "代理人战争篇",
    tag: "漫画收束段",
    keywords: ["代理人", "彩虹之子", "收官"],
    summary:
      "彩虹之子各自挑选代理人展开混战，胜负直接关系到诅咒的解除。多方势力在同一条时间线上交汇，此前的角色与矛盾几乎都在这一段里得到回应，作品也随之走向收尾。",
    points: [
      "多阵营混战，考验的是此前的所有铺垫是否扎实",
      "纲吉需要在「继承」与「自己想要的生活」之间做出选择",
      "作为终章，这一段的讨论热度长期居高不下",
    ],
  },
];

export const growthStages = [
  {
    id: "stage-1",
    phase: "被推着走",
    title: "从逃避到不得不面对",
    desc: "早期的纲吉没有任何主动性，训练、战斗、继承，全都是被里包恩和局势推着往前走。他的反抗方式也很朴素：抱怨、逃跑、求饶。这一段的意义不在于让他变强，而在于让观众看清他原本的样子。",
  },
  {
    id: "stage-2",
    phase: "为了同伴",
    title: "第一次拥有想要守护的东西",
    desc: "黑曜篇之后，纲吉开始为具体的人而战，而不是为「首领」这个身份而战。动机从被动转为主动，是他整个成长曲线里最关键的一次转折，也让后续的战斗有了情感支撑。",
  },
  {
    id: "stage-3",
    phase: "承担责任",
    title: "愿意站到大家前面",
    desc: "瓦利亚篇与未来篇里，纲吉逐渐接受自己是队伍的核心。他开始主动做决定、主动承担后果，即便仍然害怕，也不再让恐惧决定自己的行动。",
  },
  {
    id: "stage-4",
    phase: "确认自我",
    title: "在身份与自我之间做出选择",
    desc: "越靠近结尾，作品越频繁地追问同一个问题：纲吉想要成为什么样的人。他继承的是家族的期望，还是自己的意愿？结局相关的讨论，很大一部分都集中在这一层。",
  },
];